import { useEffect, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import {
  openCommandBar,
  closeCommandBar,
  toggleCommandBar,
  setQuery,
} from '../store/slices';

export function useCommandPalette() {
  const dispatch = useAppDispatch();
  const { isOpen, query } = useAppSelector((state) => state.commandBar);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        dispatch(toggleCommandBar());
      }
      if (e.key === 'Escape' && isOpen) {
        dispatch(closeCommandBar());
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [dispatch, isOpen]);

  const open = useCallback(() => dispatch(openCommandBar()), [dispatch]);
  const close = useCallback(() => dispatch(closeCommandBar()), [dispatch]);
  const updateQuery = useCallback(
    (q: string) => dispatch(setQuery(q)),
    [dispatch]
  );

  return { isOpen, query, open, close, updateQuery };
}
